import {Routes} from '@angular/router';
import {systemGuard} from "./core/guards/system.guard";
import {authGuard} from "./core/guards/auth.guard";

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/auth',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    loadChildren: () => import('./feature/system/auth/auth.routes').then(m => m.routes),
    // canActivate: [authGuard]
  },
  {
    path: 'system',
    loadChildren: () => import('./feature/system/system.routes').then(m => m.routes),
    // canActivate: [systemGuard]
  },
];
